import { PUT_PAYMENT_METHODS_LIST } from "../../constants/action-constants";

const initialState = {
  list: [],
};

const PaymentMethodsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUT_PAYMENT_METHODS_LIST:
      return { list: action.payload };
    default:
      return state;
  }
};

export default PaymentMethodsListReducer;
